import { useEffect, useState } from 'react'

import './App.css'

const motorcycleSuper = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/motorcycle-super.png";
const sedanSuper = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/sedan-super.png";
const suvSuper = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/suv-super.png";
const oversizedSuper = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/oversized-super.png";

const sedanHouse = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/sedan-house.png";
const suvHouse = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/suv-house.png";
const oversizedHouse = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/oversize-house.png";

const motorcycleBasic = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/wash-motorcycle.png";
const sedanBasic = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/wash-sedan.png";
const suvBasic = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/wash-suv.png";
const oversizedBasic = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/wash-oversized.png";


const addonWheel = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/wheel-addon.png";
const addonHeadlight = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/headlight-addon.png";
const addonLeather = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/leather-addon.png";

const addOneWheel = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/wheel-addon.png";
const addTwoWheels = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/wheel-addon.png";
const addThreeWheels = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/wheel-addon.png";
const addFourWheels = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/wheel-addon.png";
const addOneHeadlight = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/headlight-addon.png";
const addTwoHeadlights = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/headlight-addon.png";
const addOnBasicWash = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/chris-onsite-logo-gold.png";

const goodDealRestore = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/good-deal-restore.png";

const checkoutImages = {
    "menu": "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/chris-onsite-logo-gold.png",
    "addons": "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/chris-onsite-logo-gold.png",
    "wheels": addonWheel,
    "headlights": addonHeadlight,
    "motorcycle": "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/chris-onsite-logo-gold.png",
    "motorcycleSuper": motorcycleSuper,
    "sedan": "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/chris-onsite-logo-gold.png",
    "sedanSuper": sedanSuper,
    "suv": "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/chris-onsite-logo-gold.png",
    "suvSuper": suvSuper,
    "oversized": "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/chris-onsite-logo-gold.png",
    "oversizedSuper": oversizedSuper,
    "sedanHouse": sedanHouse,
    "suvHouse": suvHouse,
    "oversizedHouse": oversizedHouse,
    "motorcycleBasic": motorcycleBasic,
    "sedanBasic": sedanBasic,
    "suvBasic": suvBasic,
    "oversizeBasic": oversizedBasic,
    "oversizeSuper": oversizedSuper,
    "oversizeHouse": oversizedHouse,
    "addOneWheel": addOneWheel,
    "addTwoWheels": addTwoWheels,
    "addThreeWheels": addThreeWheels,
    "addFourWheels": addFourWheels,
    "addOneHeadlight": addOneHeadlight,
    "addTwoHeadlights": addTwoHeadlights,
    "leather": addonLeather,
    "addFullLeatherRestore": addonLeather,
    "basicWash": addOnBasicWash,
    "goodDeal": goodDealRestore
};

const motorcyclePrice1 = "$149";
const motorcyclePrice2 = "$499";

const sedanPrice1 = "$199";
const sedanPrice2 = "$279";
const sedanPrice3 = "$999";

const suvPrice1 = "$224";
const suvPrice2 = "$324";
const suvPrice3 = "$1499";

const oversizedPrice1 = "$299";
const oversizedPrice2 = "$449";
const oversizedPrice3 = "$1999";

const addonPrice1 = "$75 per wheel";
const addonPrice2 = "$99 per headlight";
const addonPrice3 = "$99 full interior restore";
const addonPrice4 = "$100 Basic Wash";
const addonPrice5 = "$299 Good Deal Restore";

function Menu() {

 const [section, setSection] = useState("menu");
 const [quantity, setQuantity] = useState(0);
 const [showQuantitySelect, setShowQuantitySelect] = useState(false);

 const handleLoadStripe = (serviceType) => {
    let theServiceType = serviceType;
    if(section !== "addons" && section !== "menu") {
        if(section === "wheels") {
            if(serviceType = "addonWheel") {
                setShowQuantitySelect(true);
                if(quantity == 1) {
                    theServiceType = "addOneWheel";
                } else if (quantity == 2) {
                    console.log("SETTING TO TWO WHEELS");
                    theServiceType = "addTwoWheels";
                } else if (quantity == 3) {
                    theServiceType = "addThreeWheels";
                } else if (quantity == 4) {
                    theServiceType = "addFourWheels";
                }
            }
        } else if(section === "headlights") {
            if(serviceType = "addonHeadlight") {
                setShowQuantitySelect(true);
                if(quantity == 1) {
                    theServiceType = "addOneHeadlight";
                } else if (quantity == 2) {
                    theServiceType = "addTwoHeadlights";
                }
            }
        } else if(serviceType === "addFullLeatherRestore") {
            setShowQuantitySelect(false);
            theServiceType = "addFullLeatherRestore";
        } else if(serviceType === "basicWash") {
            setShowQuantitySelect(false);
            theServiceType = "basicWash";
        } else {
            setShowQuantitySelect(false);
        }
    } else {
        setShowQuantitySelect(false);
    }
    window.location.href = `/checkout/${theServiceType}`;
 }

 const handleBackClick = () => {
    if(section !== "menu") {
        if(section === "wheels" || section === "headlights" || section === "leather") {
            setSection("addons");
        } else {
            setSection("menu");
        }
        return;
    } else {
        window.open("/", "_self");
    }
 }

 const handleAddOnsClick = () => {
    setSection("addons");
 }

  return (
    <>
        <section>
            <div style={{textAlign: "center", marginTop: "20px"}} onClick={() => handleBackClick()}>
                <img src={checkoutImages[section]} alt="Chris Onsite Logo" className="menu-logo" />
                {(section === "menu" || section === "addons") && <h1 className="menu-header">Choose Your Detailing Service</h1>}
            </div>
        </section>
        {section === "menu" && (
            <section>
                <div  className="menu-icons">
                    <div className="type-option" onClick={() => setSection("motorcycle")}>
                        <img src={"https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/wash-motorcycle.png"} alt="Motorcycle Icon" className="menu-icon" />
                        <h2>Motorcycle Detailing</h2>
                        <span className="click-here">Click Here</span>
                    </div>

                    <div className="type-option" onClick={() => setSection("sedan")}>
                        <img src={"https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/wash-sedan.png"} alt="Sedan Icon" className="menu-icon" />
                        <h2>Sedan Detailing</h2>
                        <span className="click-here">Click Here</span>
                    </div>

                    <div className="type-option" onClick={() => setSection("suv")}>
                        <img src={"https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/wash-suv.png"} alt="SUV Icon" className="menu-icon" />
                        <h2>SUV Detailing</h2>
                        <span className="click-here">Click Here</span>
                    </div>

                    <div className="type-option" onClick={() => setSection("oversized")}>
                        <img src={"https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/wash-oversized.png"} alt="Oversize Vehicle Icon" className="menu-icon" />
                        <h2>Oversize Vehicle Detailing</h2>
                        <span className="click-here">Click Here</span>
                    </div>
                </div>
                <div style={{ display: "flex", justifyContent: "center", margin: "20px auto" }}>
                    <div className="leave-review-btn" onClick={handleAddOnsClick}>
                        <h3 className="emoji">Add Ons!?</h3>
                    </div>
                </div>
            </section>
        )}
        {section === "motorcycle" && (
            <section>
                <div  className="menu-icons">
                    <div className="type-option" onClick={() => handleLoadStripe("motorcycleBasic")}>
                        <h3 className="price">{motorcyclePrice1}</h3>
                        <img src={motorcycleBasic} alt="Motorcycle Icon" className="menu-icon" />
                        <h2>Motorcycle: Reconditioning Detail</h2>
                        <span className="click-here">Click Here</span>
                    </div>
                    <div className="type-option" onClick={() => handleLoadStripe("motorcycleSuper")}>
                        <h3 className="price">{motorcyclePrice2}</h3>
                        <img src={motorcycleSuper} alt="Motorcycle Icon" className="menu-icon" />
                        <h2>Motorcycle: Enhanced Treatment Level and Ceramic Coating </h2>
                        <span className="click-here">Click Here</span>
                    </div>
                </div>
            </section>
        )}
        {section === "sedan" && (
            <section>
                <div className="menu-icons">
                    <div className="type-option" onClick={() => handleLoadStripe("sedanBasic")}>
                        <h3 className="price">{sedanPrice1}</h3>
                        <img src={sedanBasic} alt="Sedan Icon" className="menu-icon" />
                        <h2>Sedan: Interior + Exterior (Reconditioning Detail)</h2>
                        <span className="click-here">Click Here</span>
                    </div>
                    <div className="type-option" onClick={() => handleLoadStripe("sedanSuper")}>
                        <h3 className="price">{sedanPrice2}</h3>
                        <img src={sedanSuper} alt="Sedan Icon" className="menu-icon" />
                        <h2>Sedan: Interior + Exterior (Enhanced Treatment Detail)</h2>
                        <span className="click-here">Click Here</span>
                    </div>
                    <div className="type-option" onClick={() => handleLoadStripe("sedanHouse")}>
                        <h3 className="price">{sedanPrice3}</h3>
                        <img src={sedanHouse} alt="Sedan Icon" className="menu-icon" />
                        <h2>Sedan: Interior + Exterior + Paint Correction + Ceramic Coating + Enhanced Treatment</h2>
                        <span className="click-here">Click Here</span>
                    </div>
                </div>
            </section>
        )}
        {section === "suv" && (
            <section>
                    <div className="menu-icons">
                    <div className="type-option" onClick={() => handleLoadStripe("suvBasic")}>
                        <h3 className="price">{suvPrice1}</h3>
                        <img src={suvBasic} alt="SUV Icon" className="menu-icon" />
                        <h2>SUV: Interior + Exterior (Reconditioning Detail)</h2>
                        <span className="click-here">Click Here</span>
                    </div>
                    <div className="type-option" onClick={() => handleLoadStripe("suvSuper")}>
                        <h3 className="price">{suvPrice2}</h3>
                        <img src={suvSuper} alt="SUV Icon" className="menu-icon" />
                        <h2>SUV: Interior + Exterior (Enhanced Treatment Detail)</h2>
                        <span className="click-here">Click Here</span>
                    </div>
                    <div className="type-option" onClick={() => handleLoadStripe("suvHouse")}>
                        <h3 className="price">{suvPrice3}</h3>
                        <img src={suvHouse} alt="SUV Icon" className="menu-icon" />
                        <h2>SUV: Interior + Exterior + Paint Correction + Ceramic Coating + Enhanced Treatment</h2>
                        <span className="click-here">Click Here</span>
                    </div>
                </div>
            </section>
        )}
        {section === "oversized" && (
            <section>
                <div className="menu-icons">
                    <div className="type-option" onClick={() => handleLoadStripe("oversizeBasic")}>
                        <h3 className="price">{oversizedPrice1}</h3>
                        <img src={oversizedBasic} alt="Oversized Icon" className="menu-icon" />
                        <h2>Oversized: Interior + Exterior (Reconditioning Detail)</h2>
                        <span className="click-here">Click Here</span>
                    </div>
                    <div className="type-option" onClick={() => handleLoadStripe("oversizeSuper")}>
                        <h3 className="price">{oversizedPrice2}</h3>
                        <img src={oversizedSuper} alt="Oversized Icon" className="menu-icon" />
                        <h2>Oversized: Interior + Exterior (Enhanced Treatment Detail)</h2>
                        <span className="click-here">Click Here</span>
                    </div>
                    <div className="type-option" onClick={() => handleLoadStripe("oversizeHouse")}>
                        <h3 className="price">{oversizedPrice3}</h3>
                        <img src={oversizedHouse} alt="Oversized Icon" className="menu-icon" />
                        <h2>Oversized: Interior + Exterior + Paint Correction + Ceramic Coating + Enhanced Treatment</h2>
                        <span className="click-here">Click Here</span>
                    </div>
                </div>
            </section>
        )}
        {section === "addons" && (
            <section>
                <div className="menu-icons">
                    <div className="type-option" onClick={() => { setSection("wheels"); setShowQuantitySelect(true); }}>
                        <h3 className="price">{addonPrice1}</h3>
                        <img src={addonWheel} alt="Addon Icon" className="menu-icon" />
                        <h2>Addon: Wheel Restore</h2>
                        <span className="click-here">Click Here</span>
                    </div>
                    <div className="type-option" onClick={() => { setSection("headlights"); setShowQuantitySelect(true); }}>
                        <h3 className="price">{addonPrice2}</h3>
                        <img src={addonHeadlight} alt="Addon Icon" className="menu-icon" />
                        <h2>Addon: Headlight Restore</h2>
                        <span className="click-here">Click Here</span>
                    </div>
                    <div className="type-option" onClick={() => { handleLoadStripe("addFullLeatherRestore"); setShowQuantitySelect(false); }}>
                        <h3 className="price">{addonPrice3}</h3>
                        <img src={addonLeather} alt="Addon Icon" className="menu-icon" />
                        <h2>Addon: Full Leather Restore</h2>
                        <span className="click-here">Click Here</span>
                    </div>
                    <div className="type-option" onClick={() => { handleLoadStripe("basicWash"); setShowQuantitySelect(false); }}>
                        <h3 className="price">{addonPrice4}</h3>
                        <img src={addOnBasicWash} alt="Addon Icon" className="menu-icon" />
                        <h2>Basic Wash</h2>
                        <span className="click-here">Click Here</span>
                    </div>
                    <div className="type-option" onClick={() => { handleLoadStripe("goodDealRestore"); setShowQuantitySelect(false); }}>
                        <h3 className="price">{addonPrice5}</h3>
                        <img src={goodDealRestore} alt="Addon Icon" className="menu-icon" />
                        <h2>Good Deal Restore</h2>
                        <span className="click-here">Click Here</span>
                    </div>
                </div>
            </section>
        )}
        {section === "wheels" && (
            <section>
                <div className="quantity-select-container">
                    <h3>How Many Wheels?</h3>
                    {showQuantitySelect && (
                        <>
                            <label htmlFor="quantity-select">Select Quantity:</label>
                            <select
                                id="quantity-select"
                                value={quantity}
                                onChange={(e) => setQuantity(parseInt(e.target.value))}
                            >
                                <option value={0}>-- Select --</option>
                                <option value={1}>1 Wheel</option>
                                <option value={2}>2 Wheels</option>
                                <option value={3}>3 Wheels</option>
                                <option value={4}>4 Wheels</option>
                            </select>
                        </>
                    )}
                </div>
                <div className="menu-icons">
                    {quantity > 0 && (
                        <div className="type-option" onClick={() => handleLoadStripe("addonWheel")}>
                            <h3 className="price">{addonPrice1}</h3>
                            <img src={addonWheel} alt="Addon Icon" className="menu-icon" />
                            <h2>Checkout</h2>
                        </div>
                    )}
                </div>
            </section>
        )}
        {section === "headlights" && (
            <section>
                 <div className="quantity-select-container">
                    <h3>How Many Headlights?</h3>
                    {showQuantitySelect && (
                        <>
                            <label htmlFor="quantity-select">Select Quantity:</label>
                            <select
                                id="quantity-select"
                                value={quantity}
                                onChange={(e) => setQuantity(parseInt(e.target.value))}
                            >
                                <option value={0}>-- Select --</option>
                                <option value={1}>1 Headlight</option>
                                <option value={2}>2 Headlights</option>
                            </select>
                        </>
                    )}
                </div>
                <div className="menu-icons">
                    {quantity > 0 && (
                        <div className="type-option" onClick={() => handleLoadStripe("addonHeadlight")}>
                            <h3 className="price">{addonPrice2}</h3>
                            <img src={addonHeadlight} alt="Addon Icon" className="menu-icon" />
                            <h2>Checkout</h2>
                        </div>
                    )}
                </div>
            </section>
        )}
    </>
  )
}

export default Menu
